<div class="dialog-header" mat-dialog-title data-testid="confirm-dialog-title">
    <h4 *ngIf="title" class="ca-headline-4">
        {{ title }}
    </h4>
    <ng-container *ngIf="titleElement">
        <ng-container *ngTemplateOutlet="titleElement; context: { $implicit: context }"></ng-container>
    </ng-container>
    <button mat-icon-button class="ca-button close-button" data-testid="confirm-dialog-close-btn" (click)="close()">
        <ca-icon icon="cross"></ca-icon>
    </button>
</div>
